import {Datoformatering} from "../tjenester/Datoformatering";

export function formaterDatoUtenKlokkeslettFilterForInjisering() {
    return [Datoformatering.regNavn, formaterDatoUtenKlokkeslettFilter];
}

/**
 * Formaterer angitt dato som streng.
 * Delegerer til Datoformatering.somKalenderUtenKlokkeslett().
 */
export function formaterDatoUtenKlokkeslettFilter(datoformatering: Datoformatering): Function {
    return function (dato: Date) {
        return datoformatering.somKalenderUtenKlokkeslett(dato);
    }
}
    